"use client";

import {
	InputOTP,
	InputOTPGroup,
	InputOTPSeparator,
	InputOTPSlot,
} from "@ui/components/input-otp";

const SLOT = "size-11 text-lg";
export const CODE_LENGTH = 6;

interface CodeInputProps {
	value: string;
	onChange: (value: string) => void;
	/** Called with the code as soon as all six digits are in. */
	onComplete: (value: string) => void;
	disabled?: boolean;
}

/** The six-digit one-time code field shared by the sign-in and sign-up steps. */
export function CodeInput({
	value,
	onChange,
	onComplete,
	disabled,
}: CodeInputProps) {
	return (
		<InputOTP
			maxLength={CODE_LENGTH}
			value={value}
			onChange={(next) => {
				onChange(next);
				if (next.length === CODE_LENGTH) {
					onComplete(next);
				}
			}}
			autoComplete="one-time-code"
			autoFocus
			disabled={disabled}
			aria-label="Verification code"
			containerClassName="justify-center"
		>
			<InputOTPGroup>
				<InputOTPSlot index={0} className={SLOT} />
				<InputOTPSlot index={1} className={SLOT} />
				<InputOTPSlot index={2} className={SLOT} />
			</InputOTPGroup>
			<InputOTPSeparator className="text-muted-foreground" />
			<InputOTPGroup>
				<InputOTPSlot index={3} className={SLOT} />
				<InputOTPSlot index={4} className={SLOT} />
				<InputOTPSlot index={5} className={SLOT} />
			</InputOTPGroup>
		</InputOTP>
	);
}
